// extracted by mini-css-extract-plugin
export default {"message":"order-timeout-notifications_message__78fb7","container":"order-timeout-notifications_container__53930"};